import styled from '@mui/system/styled';
import Dialog from "@mui/material/Dialog";
import Accordion from '@mui/material/Accordion'
import LoadingButton from "@mui/lab/LoadingButton"
import { StaticDatePicker} from '@mui/x-date-pickers'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"

export const CustomeBg = styled("div")(({ theme, locale }) => ({
    backgroundImage: `url(${config.basePath}/assest/BGM.webp)`,
  }));
export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(0),
      
    },
    "& .MuiDialogAction-root": {
      padding: theme.spacing(0),
    },
  
    "& .MuiDialog-paper": {
      maxWidth: "900px !important ",
      direction: "ltr",
      display: "grid",
      justifyContent: "center",
      height:"310px",
      width:"350px",
  
      // }
  
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "white",
      },
  
      "& .MuiSelect-icon": {
        color: "teal",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 0,
        borderColor: "white",
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.2rem",
        // color:"#546e7a"
      },
    },
  }));
  export const CustomeAccordion = styled(Accordion)({
    '& .MuiSvgIcon-root ': {
      color: "#008C8D "
    },
    '& .MuiAccordion-root': {
      boxShadow: "0 0 4px #bcbcbc",
      margin: " 21px 0px",
    },
    //  '&:first-of-type':{
    margin: " 21px 0px",
    //  },
    '&:second-of-type': {
      margin: " 21px 0px",
    },
    '& .MuiTypography-root':{
        color: "#008C8D ",
        fontWeight:600
    }
  
  })
  export const Customebtn = styled(LoadingButton)({
    '&.Mui-disabled': {
      color: "grey !important",
      border: "none !important",
      backgroundColor: "#bcbcbc70 !important",
  
  },
  '&:hover':{
       
          border:"none"
  },

  

  backgroundColor: " #F52A59 ",
  fontSize: "1.2rem ",
  width: "90% ",
  border: "none",
  height: "1.0375em ",
  boxSizing: "content-box ",
  padding: " 16.5px 14px ",
  borderRadius: '12px ',
  margin: "auto ",
  display: "flex",
  border:"none ",

  '@media (min-width:768px) and (max-width:912px)': {
    backgroundColor: " #F52A59 !important",
    fontSize: "1.2rem !important",
    width: "76% !important",
    height: "1.0375em !important",
    boxSizing: "content-box !important",
    padding: " 16.5px 14px !important",
    borderRadius: '12px !important',
    border: "none !important",
    margin: "auto !important",
    display: "flex !important"
  },
  
  '@media (min-width:913px)': {
     
    backgroundColor: " #F52A59 !important",
    fontSize: "1.2rem !important",
    width: "57% !important",
    height: "1.0375em !important",
    boxSizing: "content-box !important",
    padding: " 16.5px 14px !important",
    borderRadius: '12px !important',
    border: "none !important",
    margin: "auto !important",
    display: "flex !important"
   
  }
  
  });   
  export const CutomeCalendarPicker=styled(StaticDatePicker)({
    '& .Mui-selected':{
        backgroundColor: "#F52A59 !important",
       
      
    },
 
    '& .muirtl-51cael':{
       
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    '& .MuiPickersDay-root.Mui-selected': {
        backgroundColor: "#F52A59 !important",
        color: "white",


    },
    '& .MuiPickersDay-root.Mui-selected:hover': {
        backgroundColor: "#F52A59 !important",
       
    },
    '@media (max-width:280px)': {
     
        '& .MuiCalendarPicker-root': {
            width: 230
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex",
                flexDirection: "column"
            },

        },
     

        "& .MuiPickersDay-root": {
            width: 29,
            height: 29
        },
        
    },
    '@media (min-width:320px) and  (max-width:374px)':{
        width: 280,
        minHeight: 160,
        '& .MuiTypography-root':{
            fontSize: "1rem !important",
        },
        "& .MuiPickersDay-root": {

            fontSize: "1rem  ",
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex !important",
                flexDirection: "row  "
            },


        },
    
    },
    '@media (min-width:375px) and  (max-width:390px)':{
        width: 280,
        minHeight: 160,
        '& .MuiTypography-root':{
            fontSize: "1rem !important",
        },
        "& .MuiPickersDay-root": {

            fontSize: "1rem  ",
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex !important",
                flexDirection: "column  "
            },


        },
    
    },
    '@media (min-width:391px) and  (max-width:412px)':{
        width: 280,
        minHeight: 160,
        '& .MuiTypography-root':{
            fontSize: "1rem !important",
        },
        "& .MuiPickersDay-root": {

            fontSize: "1rem  ",
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex !important",
                flexDirection: "row  "
            },


        },
    
    },
    '@media (min-width:413px) and  (max-width:767px)': {
        
        '& .MuiTypography-root':{
            fontSize: "1rem !important",
        },
        "& .MuiPickersDay-root": {

            fontSize: "1rem  ",
        },
      
            width: "100%",

        
        '& .MuiCalendarPicker-viewTransitionContainer': {
        
            "& >div": {
                display: "flex !important",
                flexDirection: "column"
            },


        },
     

        "& .MuiPickersDay-root": {
            width: 37,
            height: 37,
            fontSize: "1rem",
        },
     
        
    },
    '@media (min-width:768px) and (max-width:912px)': {
      
            width:"100%",
            minHeight:"100%",
      
            '& .MuiTypography-root':{
                fontSize: "1.2rem !important",
            },

        '& .MuiPickersDay-root': {
            width: "48px",
            fontSize: "1.2rem",
            height: "48px"
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex !important",
                flexDirection: "column"
            },

        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                "& >div": {
                    justifyContent: "space-around",
            }
        }
    },
   
    },
    '@media (min-width:913px)': {
        '& .MuiTypography-root':{
            fontSize: "1.2rem !important",
        },
        '& .MuiPickersDay-root': {
            width: "51px",
            fontSize: "1.2rem",
            height: "50px"
        },
       
            width: "500px",
           
    

        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                display: "flex !important",
                flexDirection: "column"
            },
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
            "& >div": {
                "& >div": {
                    justifyContent:"center",
                    gap:"1rem"
            }
        }
    },

    
   
     
    }
})
export const CustomeFormControlLabel = styled(FormControlLabel)({
    '& .MuiTypography-root': {
        fontSize: "1rem ",
        fontWeight: 600
    },
    '& .Mui-checked': {
        color: "#008C8D  !important"
    },
   
  
    width: "100% ",
    margin: "auto  ",
    display: "flex",
    alignItems: " center",
  
    '@media (min-width:768px) and (max-width:912px)': {
     
            width: "85% !important",
            margin: "auto",
            display: "flex",
            alignItems: " center",
            
            '& .MuiTypography-root': {
                fontSize: "1.2rem ",
                fontWeight: 600
            },
      
         
     
    },
    '@media (min-width:913px)': {
        '&.MuiTypography-root': {
            fontSize: "1.2rem ",
            fontWeight: 600
        },
     
            width: "62% !important",
            margin: "auto !important",
            display: "flex",
            alignItems: " center",
      
        
   
      

    }
})
export const CustomeFormControl = styled(FormControl)({

    '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1rem !important",
            fontWeight: 600
    },
   
 
    '& .MuiOutlinedInput-input':{
      
        boxShadow: 'none',
       },
       
        width: "100%",
        margin: 0,
        '& .MuiSvgIcon-root': {
            fontSize: "2rem !important"
        },
 
    '@media (min-width:768px) and (max-width:912px)': {
        '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1.2rem",
            fontWeight: 600
        },
      
            width: "79%",
            margin: "0 10%"
      
    },
    '@media (min-width:913px)': {
        '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1.2rem",
            fontWeight: 600
        },
            width: "60%",
            margin: "0 20%",
      
            '& .MuiSvgIcon-root': {
                fontSize: "2rem !important"
            }
    }
})
export const CustomeFormControlPatient = styled(FormControl)({

    '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1rem !important",
            fontWeight: 600
    },
   
 
    '& .MuiOutlinedInput-input':{
      
        boxShadow: 'none',
       },
       
        width: "100%",
        margin: 0,
        '& .MuiSvgIcon-root': {
            fontSize: "2rem !important"
        },
 
    '@media (min-width:768px) and (max-width:912px)': {
        '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1.2rem",
            fontWeight: 600
        },
      
            width: "100%",
            margin: "auto"
      
    },
    '@media (min-width:913px)': {
        '& .MuiInputLabel-root': {
            color: "#008C8D ",
            fontSize: "1.2rem",
            fontWeight: 600
        },
            width: "100%",
            margin: "auto",
      
            '& .MuiSvgIcon-root': {
                fontSize: "2rem !important"
            }
    }
})
export const Customeselect = styled(Select)(({locale})=>({
    
    '& .MuiSelect-select':{
        textAlign:locale=="ar"?"left":"left"

 
     },
   
    '& label.Mui-focused':{
        color:"#008C8D ",
    },
    '& .MuiSelect-icon': {
        color: "#008C8D "
    },
    '& .MuiOutlinedInput-input':{
      
        boxShadow: 'none',
       },
   
    '& .MuiInputLabel-root': {
        backgroundColor: "#f2f6f9",
        borderRadius: "8px",
      
    },
   
   
}))